import { Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useDashboardStore } from './useDashboardStore';
import { cn } from '@/lib/cn';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import CustomizePanel from './CustomizePanel';
import SupportBubble from '@/components/SupportBubble';
import ImpersonationBanner from '@/components/ImpersonationBanner';
import GuestOrgBanner from '@/components/GuestOrgBanner';
import { useMyOrganizations } from '@/hooks/useApi';
import { useAuthStore } from '@/stores/authStore';

export default function DashboardLayout({ children }: { children?: ReactNode }) {
  const expanded = useDashboardStore((s) => s.sidebarExpanded);
  const currentOrgId = useAuthStore((s) => s.organizationId);
  const { data: memberships } = useMyOrganizations();
  const ownOrg = memberships?.find((m) => m.role === 'super_admin');
  const isGuest = !!ownOrg && !!currentOrgId && currentOrgId !== ownOrg.organization.id;

  return (
    <div
      className={cn(
        'min-h-screen min-h-[100dvh] text-gray-900 transition-colors',
        isGuest ? 'bg-amber-50' : 'bg-gray-50',
      )}
    >
      <Sidebar />
      <div
        className={cn(
          'flex flex-col transition-all duration-200 ease-in-out',
          expanded ? 'md:ml-64' : 'md:ml-16',
        )}
      >
        <ImpersonationBanner />
        <GuestOrgBanner />
        <Navbar />
        <main className="flex-1 p-4 lg:p-6 pb-[calc(1rem+env(safe-area-inset-bottom))]">
          {children ?? <Outlet />}
        </main>
      </div>
      <CustomizePanel />
      <SupportBubble />
    </div>
  );
}
